import { render, staticRenderFns } from "./CartComment.vue?vue&type=template&id=a37a9f46"
import script from "./CartComment.vue?vue&type=script&lang=js"
export * from "./CartComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports